/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';
//grabbed old models from iphone_13.es5.js
  var old_models = [
    mp.marketing.trends.utils.IPHONE_13,
    mp.marketing.trends.utils.IPHONE_13_PRO,
    mp.marketing.trends.utils.IPHONE_13_PRO_MAX,
    mp.marketing.trends.utils.IPHONE_13_MINI,
    mp.marketing.trends.utils.OTHER_IPHONE,
  ];
  var release_models = [
    mp.marketing.trends.utils.IPHONE_14,
		mp.marketing.trends.utils.IPHONE_14_PLUS,
    mp.marketing.trends.utils.IPHONE_14_PRO,
    mp.marketing.trends.utils.IPHONE_14_PRO_MAX,
  ];
  var IPhone14 = mp.marketing.trends.widgets.PhoneAdoption.extend({
    get_display_models() {
      return release_models.concat(old_models);
    },
    get_release_models() {
      return release_models;
    },
    get_visible_models() {
      return release_models.concat(old_models.slice(0, 3));
    },
    get_query_name() {
      return mp.marketing.trends.utils.IPHONE_QUERY;
    },
    getDownloadName() {
      return ns.IPhone14.nice_name;
    },
  });

  Object.assign(IPhone14, {
    slug: `iphone_14`,
    nice_name: `iPhone 14 adoption`,
    description: `How quickly will people start using the new iPhone 14 models?`,
  });
  ns.IPhone14 = IPhone14;
});

}.call(window));